const colors = {
  blue: '#3c5a58',
  red: '#a74c3c',
  yellow: '#E3912C',
  orange: '#F19223',
  darkRed: '#6f1712',
  beige: '#FFECD1',
  beige2: '#FFF9F1',
  black: 'rgb(35, 31, 32)',
  secondBrown: '#D9BF98',
  ocher: '#E3912C43',
  brown: '#D9BF9843',
  whiteTrans: '#FFFFFF43',
  ticketBeige: '#FFF8EF',
  ticketRed: '#BF3720',
  lightBlue: 'rgba(186, 251, 255, 0.43)',
  burgundy: 'rgba(144, 60, 29, 1)',
};

export default colors;
